import React from "react";

import LocationToolbar from "./LocationToolbar";
import MultiLocationSummaryCards from "./MultiLocationSummaryCards";

import "./MultiLocationSummarySection.css";

export default function MultiLocationSummarySection({
  totalTests,
  consumedSummary = null,
  consumedSummaryReady = false,
  locations,
  selectedLocationKey = "all",
  onSelectLocation,
  periodLabel,
  onPeriodChange,
  loading = false,
  poolState = "ready",
  runningLowCount = 0,
}) {
  const activeLocations = locations.filter((loc) => loc.key !== "all").length;
  const selectedLocation = locations.find((loc) => loc.key === selectedLocationKey);
  const selectedLocationLabel = selectedLocationKey === "all" ? "" : selectedLocation?.label || "";

  return (
    <section className="MultiLocationSummarySection">
      <LocationToolbar
        locations={locations}
        selectedLocationKey={selectedLocationKey}
        onSelectLocation={onSelectLocation}
        periodLabel={periodLabel}
        onPeriodChange={onPeriodChange}
      />
      {loading ? null : (
        <div className="MultiLocationSummarySection__Body">
          <MultiLocationSummaryCards
            sharedPoolAvailable={totalTests}
            poolState={poolState}
            runningLowCount={runningLowCount}
            consumedSummary={consumedSummary}
            consumedSummaryReady={consumedSummaryReady}
            periodLabel={periodLabel}
            activeLocations={activeLocations}
            selectedLocationLabel={selectedLocationLabel}
          />
        </div>
      )}
    </section>
  );
}
